import { Box, Container, Typography } from "@mui/material";
import { FC, ReactNode } from "react";
import classes from "../../style";

interface ArticleLayoutProps {
  title: string;
  children: ReactNode;
}

export const ArticleLayout: FC<ArticleLayoutProps> = ({ title, children }) => (
  <Box sx={classes.defiscalisation}>
    <Container maxWidth="xl">
      <Typography variant="h1" mt={5}>
        {title}
      </Typography>
      <Box className="introduction">
        {children}
      </Box>
    </Container>
  </Box>
);
